import { Box, Button, Image } from "@enaep-ng/benchmark";
import closeIcon from "../img/closeIcon.svg";
import * as styleSheet from "../styles";
import { WarningDialogueProps } from "../types";

export default function WarningDialogue(props: WarningDialogueProps) {
  const onClose = () => {
    props.closeAction();
  };

  return (
    <Box sx={styleSheet.warningContainerBox}>
      <Box style={styleSheet.warningTitleAreaStyle}>
        <Box sx={styleSheet.warningTitleText}>{props.title}</Box>
        <Button
          variant="bare"
          onClick={onClose}
          style={styleSheet.warningCloseBtn}
        >
          <Image style={styleSheet.warningCloseImg} src={closeIcon} />
        </Button>
      </Box>
      <Box style={styleSheet.warningBodyAreaText}>{props.subTitle}</Box>
    </Box>
  );
}
